<template>
	<div class="notice">
		<div class="settingwarp">
			<header>
				<div style="display: block;">
					<div class="cu-custom" style="height: 45px;">
						<div class="cu-bar fixed bg-gradual-black" style=" height: 45px; padding-top: 0px;">
							<div class="content text-gold" style="top: 0px;">
								<div>{{$t('pingtaigonggao')}}</div>
							</div>
							<div class="action" @click="changego">
								<text class="cuIcon-back" style="width: 50px;">
									<span></span>
								</text>
							</div>
						</div>
					</div>
				</div>
			</header>
			<div style="padding: 0px 5px;">
				<div class="bg-gradual-black padding" style="margin-top: 5px; border-radius: 12px;"
					v-for="(notice, index) in filteredNotices" :key="index">
					<div class=" text-sm flex">
						<div class="action">
							<!-- <div class="text-green text-xs">{{ formatTime(notice.createtime) }}
							</div> -->
							<div class="text-green text-xs">{{ notice.title}}
							</div>
						</div>
						<div class="margin-left text-gold">
							<text>
								<span>{{ notice.content}}</span>
							</text>
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>
<script>
	import homeApi from "@/api/home";
	export default {
		name: "MoreNews",
		components: {},
		data() {
			return {
				active: 0,
				tops: null,
				articleTabs: null,
				notices: [],
				currentLang: localStorage.getItem("locale") || 'zh' // 从localStorage获取语言设置
			};
		},
		computed: {
			filteredNotices() {
				const langMap = {
					'en': 1,
					'zh': 2,
					'tw': 3
				};
				const targetId = langMap[this.currentLang] || 2;
				return this.notices.filter(item => item.article_class_id === targetId);
			}
		},
		methods: {
			formatTime(timestamp) {
				const date = new Date(timestamp * 1000)
				const month = (date.getMonth() + 1).toString().padStart(2, '0')
				const day = date.getDate().toString().padStart(2, '0')
				const year = date.getFullYear()
				return `${month}/${day}/${year}`
			},

			changego() {
				this.$router.go(-1);
			},
			info() {
				this.$toast.loading({
					message: this.$t('jiazaizhong'),
					forbidClick: true,
					duration: 0,
				});
				homeApi
					.articleList1()
					.then((data) => {
						// console.log(data, 23221);
						this.notices = data.data.articleTabs;
						// console.log(this.notices, 4533);
						// this.articleTabs = data.data.articleTabs;
						this.$toast.clear();
					})
					.catch((err) => {
						this.$toast.clear();
						this.$toast.fail(err.msg);
					});
			},
			changedetail(item) {
				console.log(item);
				let news = JSON.stringify(item);
				this.$router.push({
					path: "/AticleDetail",
					query: {
						news: news,
					},
				});
			},
		},
		mounted() {},
		created() {
			this.info();
			this.currentLang = localStorage.getItem("locale") || 'zh';
		},
	};
</script>
<style lang="less" scoped>
	.settingwarp {
		display: flex;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-ms-flex-direction: column;
		flex-direction: column;
	}

	.warpnotice {
		height: 100%;
	}

	.cu-custom {
		display: block;
		position: relative;
		box-sizing: border-box;
	}

	.bg-gradual-black {
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		color: #b8a78a;
	}

	.cu-bar .content {
		position: absolute;
		text-align: center;
		width: calc(100% - 194px);
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		margin: auto;
		height: 34px;
		font-size: 17px;
		line-height: 34px;
		cursor: none;
		pointer-events: none;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}


	.cu-bar {
		display: flex;
		position: relative;
		align-items: center;
		min-height: 57px;
	}

	.cu-bar.fixed,
	.nav.fixed {
		position: fixed;
		width: 100%;
		top: 0;
		z-index: 1024;
		box-shadow: 0 0.5px 3px rgba(0, 0, 0, .1);
	}

	.cu-custom .cu-bar {
		min-height: 0;
		box-shadow: 0px 0px 0px;
		z-index: 9999;
	}

	.cu-custom .cu-bar .content {
		width: calc(100% - 252px);
	}

	.cu-bar .action {
		display: flex;
		align-items: center;
		height: 100%;
		justify-content: center;
		max-width: 100%;
	}

	.cu-list.menu {
		display: block;
		overflow: hidden;
	}

	.cu-list.menu>.cu-item {
		position: relative;
		display: flex;
		padding: 0 17px;
		min-height: 57px;
		background-color: #fff;
		justify-content: space-between;
		align-items: center;
	}

	.cu-list>.cu-item {
		transition: all .6s ease-in-out 0s;
		-webkit-transform: translateX(0px);
		transform: translateX(0px);
	}

	.bg-gradual-black {
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		color: #b8a78a;
	}

	.cu-list.menu>.cu-item .content {
		font-size: 17px;
		line-height: 1.6em;
		flex: 1;
	}



	.text-gold,
	.line-gold,
	.lines-gold {
		color: #b8a78a;
	}

	.padding {
		padding: 17px;
	}

	.text-sm {
		font-size: 13px;
	}

	.flex {
		display: flex;
	}

	.text-green,
	.line-green,
	.lines-green {
		color: #39b54a;
	}

	.text-xs {
		font-size: 11px;
	}

	.text-gold,
	.line-gold,
	.lines-gold {
		color: #b8a78a;
	}

	.margin-left {
		margin-left: 17px;
	}
</style>